/**
 * Re-export debounce with proper typing.
 *
 * The debounce package's type definitions don't resolve correctly in some environments,
 * causing TypeScript to infer the function as an error type.
 * This file provides a properly typed re-export.
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
import _debounce from 'debounce';
/**
 * Creates a debounced function that delays invoking the provided function
 * until after the specified wait time has elapsed since the last invocation.
 *
 * @param fn - The function to debounce
 * @param wait - The number of milliseconds to delay
 * @param immediate - If true, trigger the function on the leading edge instead of trailing
 * @returns A debounced version of the function with clear() and flush() methods
 */
export function debounce(fn, wait, immediate) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return _debounce(fn, wait, immediate);
}
export default debounce;
